import makeStyles from '@mui/styles/makeStyles';
import { get } from 'global/lib/lodash';
import { isDark } from 'global/styles';

const IMAGE = 100;

const useStyles = makeStyles((theme) => ({
  dialog: {
    zIndex: `1000 !important`,
  },
  appBar: {
    position: 'relative',
  },
  toolbar: {
    height: 70,
  },
  title: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
  },
  subTitle: {
    fontSize: 15,
  },
  status: {
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
  statusIcon: {
    marginLeft: theme.spacing(2),
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '80%',
    maxWidth: 600,
    margin: '0 auto',
  },
  barTitle: {
    flexDirection: 'column',
    flex: 1,
    marginLeft: theme.spacing(2),
  },

  buttonContainer: {
    margin: theme.spacing(1),
  },
  tagButton: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
  },
  tagRemove: {
    color: theme.colors.danger,
    borderColor: theme.colors.danger,
  },
  tagContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  tagReference: {
    display: 'flex',
    alignItems: 'center',
    color: isDark(theme) ? theme.colors.white : theme.palette.secondary.main,
  },
  superText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  tagText: {
    fontSize: 14,
  },
  tagOption: {},
  tagBox: {
    margin: 4,

    '& .MuiSvgIcon-root': {
      marginBottom: -7,
    },
  },
  tagName: {
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
  },
  tagDescription: {},
  tagLink: {
    marginBottom: theme.spacing(1),
  },

  formStyle: {
    // alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
  },
  titleStyle: {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  screenWidth: {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  screenContainer: {
    maxWidth: 'none !important',
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },

  dropZone: {
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    borderRadius: 10,
    width: 'auto',
  },
  imageWrap: {
    position: 'relative',
    margin: theme.spacing(1),
    width: IMAGE,
  },
  image: {},
  imageDelete: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  comment: {
    padding: `0 ${theme.spacing(1)}`,
    backgroundColor: (props) => (get(props, 'formState.overwritten') ? 'white' : theme.palette.action.disabled),

    '& .MuiInput-underline:before, .MuiInput-underline:after': {
      border: 'none !important',
    },
    '& textarea': {
      margin: theme.spacing(1),
    },
    '& .MuiFormHelperText-root': {
      position: 'relative',
      bottom: -20,
    },
  },

  submitButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),

    '& button': {
      marginLeft: theme.spacing(2),
    },
  },
  button: {
    height: '100%',
  },
  doubleIcon: {
    position: 'relative',
    height: 24,
  },
  plusIcon: {
    position: 'absolute',
    top: 12,
    right: -2,
    fontSize: 14,
  },
  submitBtnText: {
    maxWidth: 90,
  },
}));

export default useStyles;
